import PhotoSwipe from 'photoswipe';
import React, { Component, createRef, Fragment, ReactNode } from 'react';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import 'photoswipe/dist/photoswipe.css';
import 'photoswipe/dist/default-skin/default-skin.css';
import templateString from './template.htm';

let insertTemplate = false;

class PhotoSwipeCompoennt extends Component<{ children: ReactNode }> {
    indicatorRef = createRef<HTMLDivElement>();

    public componentDidMount() {
        if (!insertTemplate) {
            insertTemplate = true;

            const div = document.createElement('div');

            div.innerHTML = templateString;

            document.body.appendChild(div);
        }

        const container = this.indicatorRef.current!.parentNode!;
        const picElems = Array.from(container.querySelectorAll('img'));

        picElems.forEach((imgItem, index) => {
            imgItem.addEventListener(
                'click',
                ev => {
                    ev.stopPropagation();
                    ev.preventDefault();

                    const items = picElems.map(img => {
                        return {
                            src: img.src,
                            w: img.naturalWidth,
                            h: img.naturalHeight
                        };
                    });

                    const gallery = new PhotoSwipe(
                        document.getElementById('photoswipe-container'),
                        PhotoSwipeUI_Default,
                        items,
                        {
                            index,
                            shareButtons: []
                        }
                    );

                    gallery.init();
                },
                false
            );
        });
    }

    public render() {
        return (
            <Fragment>
                <div style={{ display: 'none' }} ref={this.indicatorRef} />
                {this.props.children}
            </Fragment>
        );
    }
}

export default PhotoSwipeCompoennt;
